/**
 * Escape HTML to prevent XSS attacks
 * @param {string} text
 * @returns {string}
 */
function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Generate title text based on error counts
 * @param {object} counts - Error counts object
 * @returns {string} Title text
 */
function generateTitleText(counts) {
  if (counts.fixable > 0 && counts.informational > 0) {
    return `${counts.fixable} correggibili, ${counts.informational} informativi`;
  } else if (counts.fixable > 0) {
    return counts.fixable === 1
      ? '1 correzione disponibile'
      : `${counts.fixable} correzioni disponibili`;
  } else {
    return counts.informational === 1
      ? '1 errore trovato'
      : `${counts.informational} errori trovati`;
  }
}

/**
 * Create popup title with error counts
 * @param {object} counts - Error counts object
 * @returns {HTMLElement} Title element
 */
export function createPopupTitle(counts) {
  const titleText = generateTitleText(counts);

  // Compose title HTML
  const titleHtml = `
    <div class="spellcheck-popup-title">
      ${escapeHtml(titleText)}
    </div>
  `;

  // Create container and set innerHTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = titleHtml;
  return tempDiv.firstElementChild;
}
